import { CompanyWebsites } from '@/modules/homepage/CompanyWebsites/CompanyWebsites';
import { CompanyWebsitesMetadataInterface } from '@/types/homepage.types';

export const RenderCompanyWebsites = ({ websites, title }: CompanyWebsitesMetadataInterface) => {
  return <CompanyWebsites title={title} data={websites} />;
};
